import { QueryFunctionContext, useQuery } from 'react-query';
import surveyService, { AppointmentTask } from '../services/survey.service';

const getQuery = () => {
  return async (context: QueryFunctionContext) => {
    const path = context.queryKey[1] as string;
    const appointmentId = context.queryKey[2] as string;

    if (!path || !appointmentId) return { items: [] as AppointmentTask[] };

    return surveyService.listForAppointment(path, appointmentId);
  };
};

/**
 * All pre-visit tasks attached to a single appointment — surveys,
 * consents, and the request-level items (photo ID, insurance card,
 * insurance, basic information). One DDB-fanout query per fetch, so we
 * only call this for the patient's NEXT appointment to keep cost in
 * check. Skipped when either parameter is missing.
 */
const useAppointmentSurveys = (path?: string | null, appointmentId?: string | null) => {
  const enabled = !!path && !!appointmentId;
  const queryKey = ['appointmentSurveys', path || null, appointmentId || null] as const;

  const { data, isFetching, refetch } = useQuery<{ items: AppointmentTask[] }>(
    queryKey,
    getQuery(),
    {
      enabled,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 30 * 1000,
    }
  );

  return {
    items: data?.items ?? [],
    isFetching,
    refetch,
  };
};

export default useAppointmentSurveys;
